import { queryClient } from '@/client/query';
import profileRepository from '@/repositories/profile.repository';
import { useMutation } from '@tanstack/react-query';

export function useUpdateProfile() {
  return useMutation({
    mutationFn: profileRepository.updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['me', 'get'] });
    },
  });
}
